<template>
  <v-container grid-list-md fluid>

    <v-layout column align-space-between>
      <v-flex x12 class="no-print">

        <v-layout align-center justify-center>
          <v-btn small color="success" dark @click="imprimir">Imprimir</v-btn>
          <v-btn small flat color="default" :to="{ name: 'Impresiones', params: {
            codigo: this.codigo,
            datos: this.datos
          } }">Volver
          </v-btn>
        </v-layout>
      </v-flex>

      <v-flex x12>
        <v-layout align-center justify-center>
          <table width="100%">
            <tr class="text-xs-center">
              <td>
                <table width="100%">
                  <tr>
                    <td>
                      <img src="https://scai.ingana.com.co/img/convenios/logo_20180413_093840.png"
                           style="width: 100px; position: absolute; left: 50px" align="left">
                      <h1 class="pa-0 subheading font-weight-bold">LICEO FESAN</h1>

                      <span class="caption">Av. Calle 153 No. 110-40 //Suba Portal de la Mercedes//PBX <br>
                      7440048//www.liceofesan.edu.co <br>
                      Bogota D.C
                      </span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr class="text-xs-center mt-1">
              <td>
                <span class="body-1 font-weight-bold">FORMULARIO DE INSCRIPCIÓN AÑO 2020
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No {{ datos.codigo }} </span>
              </td>
            </tr>

            <tr>
              <td>
                <table width="100%" class="border-table" >
                  <tr class="text-xs-center">
                    <td>
                      <span class="body-1 font-weight-bold">INFORMACIÓN DEL ESTUDIANTE</span>
                    </td>
                    <td class="font-print" rowspan="6" width="15%">
                      <div style="width: 140px; height: 175px" class="border-table" >
                        <br>
                        <br>
                        <br>
                        Pegue aquí la foto del aspirante
                      </div>

                    </td>
                  </tr>

                  <tr class="body-1 ">
                    <td>
                      <table width="100%" class="text-xs-center font-print">
                        <tr>
                          <td class="border-table">
                            {{ datos.acapersona_preinscripcion.apellidos + ' ' + datos.acapersona_preinscripcion.nombres
                            }}
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Apellidos y Nombres completos
                          </td>
                        </tr>
                      </table>
                    </td>


                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="pt-2 font-print">
                        <tr>
                          <td>Documento Identidad:</td>
                          <td class="border-table text-xs-center">
                            {{ datos.acapersona_preinscripcion.identificacion }}
                          </td>
                          <td class="text-xs-center">
                            de:
                          </td>
                          <td class="border-table text-xs-center" width="20%">
                            {{ }}
                          </td>

                          <td class="text-xs-center">
                            Edad:
                          </td>

                          <td class="border-table text-xs-center">
                            {{ this.datos.acapersona_preinscripcion.edad }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>
                            Fecha de nacimiento:
                          </td>

                          <td class="border-table text-xs-center">
                            {{ datos.acapersona_preinscripcion.fecha_nacimiento }}
                          </td>

                          <td class="text-xs-center">
                            Nacionalidad:
                          </td>

                          <td class="border-table text-xs-center">
                            {{ datos.acapersona_preinscripcion.pais.nombre }}
                          </td>

                          <td class="text-xs-center">
                            Departamento:
                          </td>

                          <td class="border-table text-xs-center">
                            {{ datos.acapersona_preinscripcion.municipio.departamento.nombre }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>

                          <td>
                            Ciudad:
                          </td>

                          <td class="text-xs-center border-table">
                            {{ datos.acapersona_preinscripcion.municipio.nombre }}
                          </td>

                          <td class="text-xs-center">
                            Dirección
                          </td>

                          <td class="text-xs-center border-table">
                            {{ datos.acapersona_preinscripcion.direccion }}
                          </td>

                          <td class="text-xs-center">
                            Teléfono:
                          </td>

                          <td class="text-xs-center border-table">
                            {{ datos.acapersona_preinscripcion.celular }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>

                          <td>
                            Curso al que Ingresa:
                          </td>

                          <td class="text-xs-center border-table">
                            {{ datos.semestre.nombre }}
                          </td>
                          <td class="text-xs-center">
                            <!-- ¿Es repitente al curso que ingresa? -->
                          </td>
                          <td class="text-xs-center border-table">
                            <!-- {{ datos.es_repitente ? 'Si' : 'No' }} -->
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Colegio donde cursó el último grado:</td>
                          <td class="text-xs-center border-table">{{ datos.colegio_ultimo_grado }}</td>
                          <td class="text-xs-center">Año</td>
                          <td class="text-xs-center border-table">{{ datos.anio_ultimo_grado }}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                </table>
              </td>
            </tr>

            <tr>
              <td>
                <table width="100%" class="border-table mt-2 ">
                  <tr class="text-xs-center">
                    <td>
                      <span class="body-1 font-weight-bold">INFORMACIÓN DE LOS PADRES</span>
                    </td>
                  </tr>

                  <!--Datos del Padre-->
                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Nombre del Padre:</td>
                          <td class="text-xs-center border-table">
                            {{ datos.padre.acapersona_preinscripcion.nombres
                            + ' ' + datos.padre.acapersona_preinscripcion.apellidos
                            }}
                          </td>
                          <td class="text-xs-center">{{
                            datos.padre.acapersona_preinscripcion.tipoidentificacion.abreviatura }}:
                          </td>
                          <td class="text-xs-center border-table">{{
                            datos.padre.acapersona_preinscripcion.identificacion }}
                          </td>
                          <td class="text-xs-center">Vive:</td>
                          <td class="text-xs-center border-table">{{ datos.padre.actualmente_vive == '1' ? 'Si' :
                            datos.padre.actualmente_vive == '0' ? 'No' : 'N.A' }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Dirección:</td>
                          <td class="text-xs-center border-table">{{ datos.padre.acapersona_preinscripcion.direccion
                            }}
                          </td>
                          <td class="text-xs-center">Celular:</td>
                          <td class="text-xs-center border-table">{{ datos.padre.acapersona_preinscripcion.celular }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Ocupación</td>
                          <td width="20%" class="text-xs-center border-table">{{
                            datos.padre.acapersona_preinscripcion.ocupacion }}
                          </td>
                          <td class="text-xs-center">Teléfono Oficina:</td>
                          <td width="20%" class="text-xs-center border-table">{{
                            datos.padre.acapersona_preinscripcion.telefono_empresa == '' ? 'N.A'
                            : datos.padre.acapersona_preinscripcion.telefono_empresa }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <!--Datos del Padre-->

                  <!--Datos de la madre-->
                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Nombre de la Madre:</td>
                          <td class="text-xs-center border-table">
                            {{ datos.madre.acapersona_preinscripcion.nombres
                            + ' ' + datos.madre.acapersona_preinscripcion.apellidos
                            }}
                          </td>
                          <td class="text-xs-center">{{
                            datos.madre.acapersona_preinscripcion.tipoidentificacion.abreviatura }}:
                          </td>
                          <td class="text-xs-center border-table">{{
                            datos.madre.acapersona_preinscripcion.identificacion }}
                          </td>
                          <td class="text-xs-center">Vive:</td>
                          <td class="text-xs-center border-table">{{ datos.madre.actualmente_vive == '1' ? 'Si' :
                            datos.madre.actualmente_vive == '0' ? 'No' : 'N.A' }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Dirección:</td>
                          <td class="text-xs-center border-table">{{ datos.madre.acapersona_preinscripcion.direccion
                            }}
                          </td>
                          <td class="text-xs-center">Celular:</td>
                          <td class="text-xs-center border-table">{{ datos.madre.acapersona_preinscripcion.celular }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Ocupación</td>
                          <td width="20%" class="text-xs-center border-table">{{
                            datos.madre.acapersona_preinscripcion.ocupacion }}
                          </td>
                          <td class="text-xs-center">Teléfono Oficina:</td>
                          <td width="20%" class="text-xs-center border-table">{{
                            datos.madre.acapersona_preinscripcion.telefono_empresa == '' ? 'N.A'
                            : datos.madre.acapersona_preinscripcion.telefono_empresa }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <!--Datos de la madre-->
                </table>
              </td>
            </tr>

            <!--Datos del acudiente-->
            <tr>
              <td>
                <table width="100%" class="border-table mt-2">
                  <tr class="text-xs-center">
                    <td>
                      <span class="body-1 font-weight-bold">INFORMACIÓN DEL ACUDIENTE</span>
                    </td>

                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Nombre Completo:</td>
                          <td class="text-xs-center border-table">{{ datos.acudiente.acapersona_preinscripcion.nombres +
                            ' '
                            + datos.acudiente.acapersona_preinscripcion.apellidos }}
                          </td>
                          <td class="text-xs-center">Parentesco:</td>
                          <td class="text-xs-center border-table">{{ datos.acudiente.parentesco }}</td>
                        </tr>
                      </table>
                    </td>

                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Teléfono Fijo:</td>
                          <td class="text-xs-center border-table" width="20%">{{
                            datos.acudiente.acapersona_preinscripcion.telefono }}
                          </td>
                          <td class="text-xs-center">Celular:</td>
                          <td class="text-xs-center border-table">{{ datos.acudiente.acapersona_preinscripcion.celular
                            }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Correo electrónico:</td>
                          <td class="text-xs-center border-table">{{ datos.acudiente.acapersona_preinscripcion.mail }}
                          </td>
                          <td class="text-xs-center">Confirmar Correo electrónico:</td>
                          <td class="text-xs-center border-table">{{ datos.acudiente.acapersona_preinscripcion.mail }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td class="text-xs-center">
                            ¿Por qué desea estudiar en este Colegio?
                          </td>
                        </tr>
                        <tr>
                          <td class=" border-table pa-1">
                            {{ datos.este_colegio }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="text-xs-right font-print">
                        <tr>
                          <td width="20%">
                            Prueba diagnóstica:
                          </td>
                          <td class="border-table"></td>
                          <td width="20%">
                            Fecha:
                          </td>
                          <td class="border-table"></td>
                          <td width="20%">
                            Hora
                          </td>
                          <td class="border-table"></td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                </table>
              </td>
            </tr>
            <!--Datos del acudiente-->

            <!--Datos del responsable economico-->
            <tr>
              <td>
                <table width="100%" class="border-table mt-2">
                  <tr class="text-xs-center">
                    <td>
                      <span class="body-1 font-weight-bold">INFORMACIÓN RESPONSABLE ECONÓMICO</span>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Nombre Completo:</td>
                          <td class="text-xs-center border-table">{{ datos.responsable.acapersona_preinscripcion.nombres
                            + ' '
                            + datos.responsable.acapersona_preinscripcion.apellidos }}
                          </td>
                          <td class="text-xs-center">Parentesco</td>
                          <td class="text-xs-center border-table">{{ datos.responsable.parentesco }}</td>
                        </tr>
                      </table>
                    </td>

                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Dirección:</td>
                          <td class="text-xs-center border-table">{{
                            datos.responsable.acapersona_preinscripcion.direccion }}
                          </td>
                          <td class="text-xs-center">Teléfono Fijo:</td>
                          <td width="20%" class="text-xs-center border-table">{{
                            datos.responsable.acapersona_preinscripcion.telefono }}
                          </td>
                          <td class="text-xs-center">Celular:</td>
                          <td class="text-xs-center border-table">{{ datos.responsable.acapersona_preinscripcion.celular
                            }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>Correo electrónico:</td>
                          <td class="text-xs-center border-table">{{ datos.responsable.acapersona_preinscripcion.mail
                            }}
                          </td>
                          <td class="text-xs-center">Confirmar Correo electrónico:</td>
                          <td class="text-xs-center border-table">{{ datos.responsable.acapersona_preinscripcion.mail
                            }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                </table>
              </td>
            </tr>
            <!--Datos del responsable economico-->

            <tr>
              <td>
                <table width="100%" class="text-xs-center mt-4">
                  <tr>
                    <td class="text-xs-center">
                      _________________________________
                    </td>

                    <td class="text-xs-center">
                      _________________________________
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-center">Firma Estudiante</td>
                    <td class="text-xs-center">Firma Acudiente</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <span class="caption">
                        La adquisición del formulario de inscripción no garantiza la obtención del cupo y por ningún motivo su valor es reembolsable.
                      </span>

                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="border-table" style="border-style: dashed">

              </td>
            </tr>

            <tr>
              <td class="text-xs-center">
                <span class="caption">
                  La adquisición del formulario de inscripción no garantiza la obtención del cupo y por ningún motivo su valor es reembolsable.
                </span>
              </td>
            </tr>

            <!--Desprendible-->
            <tr>
              <td>
                <table width="100%" class="border-table mt-2 font-print">
                  <tr class="body-1 text-xs-center">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>
                              LICEO FESAN
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Av. Calle 153 No. 110-40 //Suba Portal de la Mercedes//PBX
                          </td>
                        </tr>

                        <tr>
                          <td>
                            7440048//www.liceofesan.edu.co
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Bogota D.C
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr class="text-xs-center">
                    <td>
                      <span class="body-1 font-weight-bold">DESPRENDIBLE FORMULARIO DE INSCRIPCIÓN AÑO 2019
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No {{ datos.codigo }} </span>

                    </td>
                  </tr>

                  <tr class="body-1">
                    <td>
                      <table width="100%" class="font-print">
                        <tr>
                          <td>
                            <table width="100%" class="text-xs-center">
                              <tr>
                                <td width="40%" class="text-xs-center border-table">
                                  {{ datos.acapersona_preinscripcion.apellidos + ' ' +
                                  datos.acapersona_preinscripcion.nombres
                                  }}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  Apellidos y Nombres completos
                                </td>
                              </tr>
                            </table>
                          </td>


                        </tr>

                        <tr class="body-1">
                          <td>
                            <table width="100%" class="pt-1 font-print">
                              <tr>
                                <td>Documento Identidad:</td>
                                <td class="text-xs-center border-table">
                                  {{ datos.acapersona_preinscripcion.identificacion }}
                                </td>
                                <td class="text-xs-center">
                                  de:
                                </td>
                                <td width="30%" class="text-xs-center border-table">
                                  {{ }}
                                </td>

                                <td class="text-xs-center">
                                  Edad:
                                </td>

                                <td class="text-xs-center border-table">
                                  {{ this.datos.acapersona_preinscripcion.edad }}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr class="body-1">
                          <td>
                            <table width="100%" class="font-print">
                              <tr>
                                <td>
                                  Dirección
                                </td>

                                <td class="text-xs-center border-table">
                                  {{ datos.acapersona_preinscripcion.direccion }}
                                </td>

                                <td class="text-xs-center">
                                  Celular:
                                </td>

                                <td class="text-xs-center border-table">
                                  {{ datos.acapersona_preinscripcion.celular }}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr class="body-1 pt-1">
                          <td>
                            <table width="100%" class="text-xs-right font-print">
                              <tr>
                                <td width="20%">
                                  Prueba diagnóstica:
                                </td>
                                <td class="border-table"></td>
                                <td width="20%">
                                  Fecha:
                                </td>
                                <td class="border-table"></td>
                                <td width="20%">
                                  Hora
                                </td>
                                <td class="border-table"></td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr class="body-1">
                          <td>
                            <table width="100%" class="text-xs-right font-print">
                              <tr>
                                <td width="20%">
                                  Entrevista:
                                </td>
                                <td class="border-table"></td>
                                <td width="20%">
                                  Fecha:
                                </td>
                                <td class="border-table"></td>
                                <td width="20%">
                                  Hora
                                </td>
                                <td class="border-table"></td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <!--Desprendible-->
          </table>
        </v-layout>
      </v-flex>
    </v-layout>


  </v-container>
</template>

<script>
  import Api from '../service/api'
  import moment from 'moment'

  export default {
    name: "FormularioInscripcion",
    data() {
      return {
        codigo: '',
        datos: {},
      }
    },
    mounted() {
      this.codigo = this.$route.params.codigo

      this.getDatosPreInscripcion().then(res => {
        this.datos = res
        var fecha_nac = moment(this.datos.acapersona_preinscripcion.fecha_nacimiento, 'DD/MM/YYYY')
        this.datos.acapersona_preinscripcion.edad = moment().diff(fecha_nac, 'years')
        if (!this.datos.madre) {
          this.datos.madre = {
            acapersona_preinscripcion: {
              nombres: '',
              tipoidentificacion: {
                abreviatura: 'CC'
              },
              apellidos: '',
              direccion: '',
              celular: '',
              telefono_empresa: '',
              ocupacion: '',
            },
          }
        }

        if (!this.datos.padre) {
          this.datos.padre = {
            acapersona_preinscripcion: {
              nombres: '',
              tipoidentificacion: {
                abreviatura: 'CC'
              },
              apellidos: '',
              direccion: '',
              celular: '',
              telefono_empresa: '',
              ocupacion: '',
            },
          }
        }
      })
    },
    methods: {
      imprimir() {
        window.print()
      },
      getDatosPreInscripcion() {
        return Api(`{
          acapre_inscripcion(codigo: "${this.codigo}") {
            id
            codigo
            formatodocumento_id
            semestre_id
            semestre{
              id
              nombre
            }
            es_repitente
            colegio_ultimo_grado
            anio_ultimo_grado
            este_colegio
            prepersona_id
            acapersona_preinscripcion{
              id
              tipoidentificacion_id
              tipoidentificacion{
                id
                abreviatura
                name
              }
              identificacion
              nombre1
              nombre2
              apellido1
              apellido2
              nombres
              apellidos
              fecha_nacimiento
              pais_id
              pais{
                id
                nombre
              }
              municipio_id
              municipio{
                id
                nombre
                departamento_id
                departamento{
                  id
                  nombre
                }

              }
              direccion
              celular
            }

            madre {
              id
              prepersona_id
              preacudiente_id
              parentesco
              responsable_economico
              acudiente
              actualmente_vive
              acapersona_preinscripcion {
                id
                tipoidentificacion_id
                tipoidentificacion{
                  id
                  name
                  abreviatura
                }
                identificacion
                nombre1
                nombre2
                apellido1
                apellido2
                nombres
                apellidos
                telefono
                celular
                mail
                direccion
                ocupacion
                telefono_empresa
              }
            }
            padre{
              id
              prepersona_id
              preacudiente_id
              parentesco
              responsable_economico
              acudiente
              actualmente_vive
              acapersona_preinscripcion {
                id
                tipoidentificacion_id
                tipoidentificacion{
                  id
                  name
                  abreviatura
                }
                identificacion
                nombre1
                nombre2
                apellido1
                apellido2
                nombres
                apellidos
                telefono
                celular
                mail
                direccion
                ocupacion
                telefono_empresa
              }
            }

            acudiente {
              id
              prepersona_id
              preacudiente_id
              parentesco
              responsable_economico
              acudiente
              acapersona_preinscripcion {
                id
                tipoidentificacion_id
                identificacion
                nombre1
                nombre2
                apellido1
                apellido2
                nombres
                apellidos
                telefono
                celular
                mail
                ocupacion
                telefono_empresa
              }
            }

            responsable {
              id
              prepersona_id
              preacudiente_id
              parentesco
              responsable_economico
              acudiente
              acapersona_preinscripcion {
                id
                tipoidentificacion_id
                identificacion
                nombre1
                nombre2
                apellido1
                apellido2
                nombres
                apellidos
                telefono
                celular
                mail
                direccion
                ocupacion
                telefono_empresa
              }
            }
          }
        }
        `).then(res => {
          return res.acapre_inscripcion
        })
      },
    }
  }
</script>

<style scoped>
  .border-table {
    border: 1px solid;
    border-radius: 10px;
  }

  @media print {
    .font-print {
      font-size: 11px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/FormularioInscripcion.vue